export function accordionCallout() {
    let $accordionItem = $(".content-accordion .accordion-item .accordion-title");

    $accordionItem.on("click", function (e) {
        e.preventDefault();
        let $this = $(this);
        let $parentItem = $this.closest('.accordion-item');
        let $content = $parentItem.find('.accordion-content');

        if (!$parentItem.hasClass("active")) {
            $('.content-accordion .accordion-item').removeClass("active");
            $('.content-accordion .accordion-item .accordion-content').slideUp(300);
            $parentItem.addClass("active");
            $content.slideDown(300);
        } else {
            $parentItem.removeClass("active");
            $content.slideUp(300);
        }
    });

    // Hide all .accordion-content containers by default
    $(".content-accordion .accordion-item .accordion-content").hide();
}



// WEBPACK FOOTER //
// ./assets/js/modules/accordionCallout.js